import angular from "angular";
import core from "../../core/core.module";
import mobiusNotification from "../mobius-notification";

angular
    .module('mobiusControl.notificationForm', [core, mobiusNotification])
    .component('notificationForm', {
        controller: ['notifier', 'MobiusNotification', controller],
        template: require('./notification-form.html'),
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller(notifier, MobiusNotification) {

    let $ctrl = this;

    $ctrl.$onInit = function () {

        $ctrl.requests = $ctrl.resolve.requests;
        $ctrl.errorTypes = $ctrl.resolve.errorTypes;

        $ctrl.id = null;
        $ctrl.errorType = null;
        $ctrl.errorCode = null;
        $ctrl.errorMessage = null;
        $ctrl.requestSlug = null;
        $ctrl.emails = null;

        if ($ctrl.resolve.notification) {
            $ctrl.id = $ctrl.resolve.notification.id;
            $ctrl.errorType = $ctrl.resolve.notification.errorType;
            $ctrl.errorCode = $ctrl.resolve.notification.errorCode;
            $ctrl.errorMessage = $ctrl.resolve.notification.errorMessage;
            $ctrl.requestSlug = $ctrl.resolve.notification.requestSlug;
            $ctrl.emails = $ctrl.resolve.notification.emails;
        }

    };

    $ctrl.submit = function () {

        let params = {
            errorType: $ctrl.errorType,
            errorCode: $ctrl.errorCode,
            errorMessage: $ctrl.errorMessage,
            requestSlug: $ctrl.requestSlug,
            emails: $ctrl.emails,
        };

        $ctrl.loading = true;

        let defer = $ctrl.id ? MobiusNotification.update($ctrl.id, params) : MobiusNotification.store(params);

        defer.then(
            function (response) {
                $ctrl.loading = false;
                if ($ctrl.id) {
                    notifier.successNotify('Данные успешно обновились');
                } else {
                    notifier.successNotify('Данные успешно сохранились');
                    params.id = response.data.id;
                }
                $ctrl.close({$value: params});
            },
            function (error) {
                $ctrl.loading = false;
                notifier.errorResponseNotify(error);
            }
        );
    };

}

export default 'mobiusControl.notificationForm';



// WEBPACK FOOTER //
// ./resources/assets/modules/mobius-control/notification-form/notification-form.js